import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/dag3rkhtto0ceqqnhlc0";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "ok" | "error">("idle");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("contact_alt") as string) || "").trim();

    if (honeypot) {
      setStatus("ok");
      setMsg("已收到，感谢关注我们的深挖线索。");
      form.reset();
      return;
    }

    setStatus("loading");
    const params = new URLSearchParams();
    for (const [key, value] of fd.entries()) {
      if (!String(value).trim()) continue;
      if (key === "contact_alt") continue;
      params.append(key, String(value));
    }

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        /* ignore */
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const ok = res.ok && parsed?.code === "OK" && !/spam/i.test(text);
      if (ok) {
        setStatus("ok");
        setMsg("订阅成功，独家幕后线索将每周直抵你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-[1400px] overflow-hidden rounded-2xl bg-primary-600">
        <div className="relative grid grid-cols-1 gap-8 p-8 md:p-12 lg:grid-cols-2 lg:items-center">
          <div className="pointer-events-none absolute -top-16 right-0 h-64 w-64 rounded-full bg-accent-500/30 blur-3xl"></div>
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-100">NEWSLETTER · 深挖线索</p>
            <h2 className="font-heading text-2xl font-black text-background-50 md:text-4xl">
              每周一份，把幕后链送到你手里
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-50 md:text-base">
              订阅后你将收到每周精选的独家调查、来源拆解与后台复盘，不含广告轰炸，随时可退订。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-primary-50">
                <i className="ri-lock-2-line"></i> 信息加密保护
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-primary-50">
                <i className="ri-mail-open-line"></i> 每周二准时送达
              </span>
            </div>
          </div>

          <div>
            <form
              data-readdy-form
              onSubmit={onSubmit}
              className="rounded-xl bg-background-50 p-6 md:p-7"
            >
              <div className="flex flex-col gap-3">
                <label htmlFor="newsletter-email" className="text-sm font-semibold text-foreground-950">
                  你的邮箱
                </label>
                <input
                  id="newsletter-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
                />
              </div>
              <input
                type="text"
                name="contact_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="expo-hp"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-4 inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 disabled:opacity-60"
              >
                {status === "loading" ? "提交中…" : "订阅深挖线索"}
                {status !== "loading" && <i className="ri-arrow-right-line ml-2"></i>}
              </button>
              {status === "ok" && (
                <p className="mt-3 flex items-center gap-1.5 rounded-md bg-green-100 px-3 py-2 text-sm text-green-800">
                  <i className="ri-checkbox-circle-fill"></i> {msg}
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 flex items-center gap-1.5 rounded-md bg-primary-100 px-3 py-2 text-sm text-primary-700">
                  <i className="ri-error-warning-fill"></i> {msg}
                </p>
              )}
              <p className="mt-3 text-xs leading-relaxed text-foreground-500">
                提交即表示你同意我们依据《隐私说明》处理该信息，用于发送内容邮件。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}